import { render, staticRenderFns } from "./FiltroSinistralidade.vue?vue&type=template&id=beca5568"
import script from "./FiltroSinistralidade.vue?vue&type=script&lang=js"
export * from "./FiltroSinistralidade.vue?vue&type=script&lang=js"
import style0 from "./FiltroSinistralidade.vue?vue&type=style&index=0&id=beca5568&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports